@if(contractDetails()){
  <div class="header">
    @if (contractDetails().verified) {
      <lib-verified-message></lib-verified-message>
    }
    <div class="header-stats">
      <div class="header-stat">
        <p class="header-stat-title">Region</p>
        <p class="header-stat-data">{{ contractDetails().region}}</p>
      </div>
      <div class="header-stat">
        <p class="header-stat-title">State</p>
        <p class="header-stat-data">{{ contractDetails().stateAbbreviation | stateAbbrToName }}</p>
      </div>
      <div class="header-stat">
        <p class="header-stat-title">Date</p>
        <p class="header-stat-data">{{ contractDetails().contractStartDate | slice:0:10 | date:'MM/yyyy' }}</p>
      </div>
    </div>
  </div>
}

@for (section of tableSections; track $index) {
  @if(section.header === 'Salary Information'){
    <table>
      <thead>
        <tr>
          <th colspan="2">{{section.header}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="field-title">Base Salary</td>
          @if(contractDetails()){
            <td class="field-data">{{contractDetails().salary | rdata:'salary'}}
            @if(contractDetails().negotiatedSalaryDifference){
              <lib-rdata-badge>
                {{ contractDetails().negotiatedSalaryDifference | rdata:'negotiatedSalaryDifference' | abbreviateNumber }}
                <span tooltip>{{contractDetails().negotiatedSalaryDifference | abbreviateNumber}} negotiated increase.</span>
              </lib-rdata-badge>    
            }            
          </td>
          }
          @else {
            <ng-container *ngTemplateOutlet="redacted"></ng-container>
          }
        </tr>
        <tr>
          <th class="subsection" colspan="2">Shift Rates</th>              
        </tr>
        <ng-container *ngTemplateOutlet="payRateTable; context: {$implicit: contractDetails()?.shiftRates, type: 'shifts'}"></ng-container>
        <tr>
          <th class="subsection" colspan="2">Hourly Rates</th>              
        </tr>
        <ng-container *ngTemplateOutlet="payRateTable; context: {$implicit: contractDetails()?.hourlyRates, type: 'hours'}"></ng-container>
      </tbody>
      <tfoot>
        <tr class="details-field">
          <th class="field-title subsection">Guaranteed Compensation</th>
          @if(contractDetails()){
            <td class="field-data subsection">
            {{ contractDetails().guaranteedCompensation | rdata:'guaranteedCompensation' }}
            @if(contractDetails().negotiatedGuaranteedCompensationDifference){
              <lib-rdata-badge>
                {{ contractDetails().negotiatedGuaranteedCompensationDifference | rdata:'negotiatedGuaranteedCompensationDifference' | abbreviateNumber }}
                <span tooltip>{{contractDetails().negotiatedGuaranteedCompensationDifference | abbreviateNumber}} negotiated increase.</span>
              </lib-rdata-badge>   
            }    
            </td>
          }
          @else {
            <td class="field-data subsection">
              <lib-redacted>Unknown</lib-redacted>
            </td>
          }
        </tr>
      </tfoot>
    </table>
  }
  @else {
    <table [attr.aria-hidden]="!contractDetails()">
      <tr>
        <th colspan="2">{{ section.header }}</th>
      </tr>
      @for (field of section.fields; track $index) {
      <tr class="details-field">
        <td class="field-title">{{ field.title }}</td>
        @if (contractDetails()) {
        <td *ngIf="contractDetails(); else redacted" class="field-data">
          @if(field.dataPoint === 'bonusRate'){
            {{ contractDetails()[field.dataPoint]| rdata:field.dataPoint:contractDetails()['productionBonusType'] }}
          }
          @else if (field.dataPoint === 'bonusThreshold') {
            {{ contractDetails()[field.dataPoint] | rdata:field.dataPoint:contractDetails()['productionBonusType']}}
          }
          @else if(field.dataPoint === 'signingBonus' && contractDetails().negotiatedSigningBonusDifference){
            {{contractDetails()[field.dataPoint]| rdata:field.dataPoint}}
            <lib-rdata-badge>
              {{ contractDetails().negotiatedSigningBonusDifference | rdata:'negotiatedSigningBonusDifference' | abbreviateNumber}}
              <span tooltip>{{contractDetails().negotiatedSigningBonusDifference | abbreviateNumber}} negotiated increase.</span>
            </lib-rdata-badge>
          }
          @else {
            {{contractDetails()[field.dataPoint] | rdata:field.dataPoint}}
          }
        </td>
        }
      </tr>
      }
    </table>
  }
}

<ng-template #redacted>
  <td>
    <lib-redacted>Unknown</lib-redacted>
  </td>
</ng-template>

<ng-template #payRateTable let-rates let-type="type">
  <tr class="details-field">
    <td class="field-title">Day</td>
    @if(rates){
      <td class="field-data">
        @if(rates?.dayRate !== null){
          {{rates.dayCount ?? 0}} {{type}}/{{rates.dayCountDuration | salaryRateDuration:'year'}} at {{rates.dayRate ?? 0 | currency}}
        }
        @else {
        -
        }
      </td>
    }
    @else {
      <ng-container *ngTemplateOutlet="redacted"></ng-container>
    }
  </tr>
  <tr class="details-field">
    <td class="field-title">Night</td>
    @if(rates){
      <td class="field-data">
        @if(rates?.nightRate !== null){
          {{rates.nightCount ?? 0}} {{type}}/{{rates.nightCountDuration | salaryRateDuration:'year'}} at {{rates.nightRate ?? 0 | currency}}
        }
        @else {
        -
        }        
      </td>
    }
    @else {
      <ng-container *ngTemplateOutlet="redacted"></ng-container>
    }
  </tr>
  <tr class="details-field">
    <td class="field-title">Swing</td>
    @if(rates){
      <td class="field-data">
        @if(rates?.swingRate !== null){
          {{rates.swingCount ?? 0}} {{type}}/{{rates.swingCountDuration | salaryRateDuration:'year'}} at {{rates.swingRate ?? 0 | currency}}
        }
        @else {
        -
        }        
      </td>
    }
    @else {
      <ng-container *ngTemplateOutlet="redacted"></ng-container>
    }
  </tr>
  <tr class="details-field">
    <td class="field-title">Weekend</td>
    @if(rates){
      <td class="field-data">
        @if(rates?.weekendRate !== null){
          {{rates.weekendCount ?? 0}} {{type}}/{{rates.weekendCountDuration | salaryRateDuration:'year'}} at {{rates.weekendRate ?? 0 | currency}}
        }
        @else {
        -
        }
      </td>
    }
    @else {
      <ng-container *ngTemplateOutlet="redacted"></ng-container>
    }
  </tr>
  <tr class="details-field">
    <td class="field-title">Holiday</td>
    @if(rates){
      <td class="field-data">
        @if(rates?.holidayRate !== null){
          {{rates.holidayCount ?? 0}} {{type}}/{{rates.holidayCountDuration | salaryRateDuration:'year'}} at {{rates.holidayRate ?? 0 | currency}}
        }
        @else {
        -
        }
      </td>
    }
    @else {
      <ng-container *ngTemplateOutlet="redacted"></ng-container>
    }
  </tr>
</ng-template>
